import { render, staticRenderFns } from "./serviceProperties.vue?vue&type=template&id=83c6b160&scoped=true"
import script from "./serviceProperties.vue?vue&type=script&lang=ts"
export * from "./serviceProperties.vue?vue&type=script&lang=ts"
import style0 from "./serviceProperties.vue?vue&type=style&index=0&id=83c6b160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c6b160",
  null
  
)

export default component.exports